import React, { useEffect, useState } from 'react';

import { Card } from 'antd';

import ReactEcharts from 'echarts-for-react';

import AppointmentsTable from '../../../layout/components/appointmentsTable/AppointmentsTable';
import hospitalOptions from './charts/hospital-options';
import { incomeInWeek, incomeInMonth } from './charts/income-options';
import jwt_decode from "jwt-decode";

import {
  patientsGenderOptions,
  departmentsOptions,
  patientsAgeOptions
} from './charts/patients-options';

import { useFetchPageData, usePageData } from '../../../hooks/usePage';

import { IAppointment } from '../../../interfaces/patient';
import { IPageData } from '../../../interfaces/page';

const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Dashboards',
      route: 'default-dashboard'
    },
    {
      title: 'Inicio'
    }
  ]
};

const DashboardPage = () => {
  const token: any = jwt_decode(localStorage.getItem('token'));
  const _usr = JSON.parse(token.data);
  const usuario = {
    nombres: _usr.Nombres,
    apellidos: _usr.Apellidos,
    roles:_usr.Roles
  };
  usePageData(pageData);
  const [usr, setUsr] = useState({});
  return (
    <>
      <div className='row'>
        <div className='col-12 col-md-6 col-xl-3'>
          <Card style={{ background: 'rgba(251, 251, 251)' }} className='animated with-shadow'>
            <div className='row'>
              <div className='col-5'>
                <span
                  className='icofont icofont-first-aid-alt'
                  style={{ fontSize: 48 }}
                />
              </div>

              <div className='col-7'>
                <h6 className='mt-0 mb-1'>Citas</h6>
                <div className='count' style={{ fontSize: 20, lineHeight: 1.4 }}>
                  213
                </div>
              </div>
            </div>
          </Card>
        </div>

        <div className='col-12 col-md-6 col-xl-3'>
          <Card style={{ background: 'rgba(251, 251, 251)' }} className='animated with-shadow'>
            <div className='row'>
              <div className='col-5'>
                <span
                  className='icofont icofont-wheelchair'
                  style={{ fontSize: 48 }}
                />
              </div>

              <div className='col-7'>
                <h6 className='mt-0 mb-1'>Pacientes</h6>
                <div className='count' style={{ fontSize: 20, lineHeight: 1.4 }}>
                  213
                </div>
              </div>
            </div>
          </Card>
        </div>

        <div className='col-12 col-md-6 col-xl-3'>
          <Card style={{ background: 'rgba(251, 251, 251)' }} className='animated with-shadow'>
            <div className='row'>
              <div className='col-5'>
                <span
                  className='icofont icofont-blood'
                  style={{ fontSize: 48 }}
                />
              </div>

              <div className='col-7'>
                <h6 className='mt-0 mb-1'>Observados</h6>
                <div className='count' style={{ fontSize: 20, lineHeight: 1.4 }}>
                  23
                </div>
              </div>
            </div>
          </Card>
        </div>

        <div className='col-12 col-md-6 col-xl-3'>
          <Card style={{ background: 'rgba(251, 251, 251)' }} className='animated with-shadow'>
            <div className='row'>
              <div className='col-5'>
                <span
                  className='icofont icofont-dollar-true'
                  style={{ fontSize: 48 }}
                />
              </div>

              <div className='col-7'>
                <h6 className='mt-0 mb-1'>Ingresos</h6>
                <div className='count' style={{ fontSize: 20, lineHeight: 1.4 }}>
                  $5238
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <Card title={usuario.nombres}>
        {
          usuario.roles.map(function(elem){
            return elem.Nombre;
          }).join(",")
        }
        <ReactEcharts className='chart-container container-h-400' option={hospitalOptions} />
      </Card>

      <div className='row'>
        <div className='col-sm-12 col-md-6'>
          <Card>
            <h4 className='mt-0 mb-1'>S/. 25038</h4>
            <p className='mb-0' style={{ color: '#9d9d9d' }}>
              Ingresos en el mes actual
            </p>

            <ReactEcharts className='chart-container' option={incomeInMonth} />
          </Card>
        </div>

        <div className='col-sm-12 col-md-6'>
          <Card>
            <h4 className='mt-0 mb-1'>S/. 2195</h4>
            <p className='mb-0' style={{ color: '#9d9d9d' }}>
              Ingresos en la semana actual
            </p>

            <ReactEcharts className='chart-container' option={incomeInWeek} />
          </Card>
        </div>
      </div>

      <div className='row'>
        <div className='col-12 col-md-4'>
          <Card title={'patients age'}>
            <ReactEcharts className='chart-container container-h-300' option={patientsAgeOptions} />
          </Card>
        </div>

        <div className='col-12 col-md-4'>
          <Card title={'patients gender'}>
            <ReactEcharts
              className='chart-container container-h-300'
              option={patientsGenderOptions}
            />
          </Card>
        </div>

        <div className='col-12 col-md-4'>
          <Card title={'Departments'}>
            <ReactEcharts className='chart-container container-h-300' option={departmentsOptions} />
          </Card>
        </div>
      </div>

      <Card title='Ultimos ingresos' className='mb-0'>

      </Card>
    </>
  );
};

export default DashboardPage;
